namespace GeniuzPOS.Inventory {
    export namespace IcStockApproveHdService {
        export const baseUrl = 'Inventory/IcStockApproveHd';

        export declare function Create(request: Serenity.SaveRequest<IcStockApproveHdRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IcStockApproveHdRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcStockApproveHdRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcStockApproveHdRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/IcStockApproveHd/Create",
            Update = "Inventory/IcStockApproveHd/Update",
            Delete = "Inventory/IcStockApproveHd/Delete",
            Retrieve = "Inventory/IcStockApproveHd/Retrieve",
            List = "Inventory/IcStockApproveHd/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcStockApproveHdService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
